import {
    type COLLECTION_GLOBAL_TAG,
    type PROMO_RECOMMENDATIONS_GLOBAL_TAG,
    type PROMOS_LIST_GLOBAL_TAG,
} from '#shared/api/globalTags';
import { type OpenApiSchemaDiscount } from '#shared/api/schema';
import { createGetByIdHookWithPreviewData } from '#shared/lib/requests';
import { discountApi } from '../../api/api';

function isDiscountModel(data: unknown): data is Partial<OpenApiSchemaDiscount> {
    return (
        typeof data === 'object' &&
        typeof data !== 'undefined' &&
        data !== null &&
        ('discount_value' in data || 'id' in data || 'title' in data)
    );
}

export const useDiscountGetByIdWithPreviewData = createGetByIdHookWithPreviewData<
    OpenApiSchemaDiscount,
    'discount',
    'Discount' | typeof COLLECTION_GLOBAL_TAG | typeof PROMOS_LIST_GLOBAL_TAG | typeof PROMO_RECOMMENDATIONS_GLOBAL_TAG
>({
    validatePreviewData: isDiscountModel,
    endpoint: discountApi.endpoints.getById,
});
